// chart-cta.component.ts
// Web Component for the CTA overlay

// @ts-ignore
import styleCSS from "./chart-cta.component.scss?inline"
// @ts-ignore
import templateHTML from "./chart-cta.component.html?raw"
import { i18n } from "../../../core/services/i18n-service";
import { chartService } from "../../services/charts.service";

export class ChartCtaComponent extends HTMLElement {

    //TODO : handle cta display by server response
    private _shadowRoot: ShadowRoot;
    private _cta: HTMLElement;

    constructor() {
        super();
        this._shadowRoot = this.attachShadow({ mode: "open" });

    }
    connectedCallback() {
        this.init();
        this.shadowRoot?.querySelectorAll<HTMLElement>('[i18n]').forEach((elem) => {
            const key = elem.getAttribute('i18n');
            if (key) {
              elem.innerText = i18n.t(key);
            }
          });
    }

    init() {
        const style = document.createElement('style');
        style.textContent = styleCSS;
        this._shadowRoot.appendChild(style);

        this._cta = document.createElement('div');
        this._cta.classList.add('cta');
        this.hide();
        this._cta.innerHTML = templateHTML;

        this._shadowRoot.appendChild(this._cta);
    }

    public show() {
        this._cta.style.display = 'flex';
    }

    public hide() {
        this._cta.style.display = 'none';
    }
}

window.customElements.define("chart-cta", ChartCtaComponent);